import MetaColumn from './MetaColumn';
import GeneralForm from './../Forms/GeneralForm';

const HomePageBuilder = {
    component: GeneralForm,
    options: {
        columns: {
            meta: MetaColumn,
        }
    }
};

export default HomePageBuilder;


// WEBPACK FOOTER //
// ./src/containers/Pages/Builders/HomePageBuilder.js